export const applyGlobalScripts = () => {
  document.addEventListener('wheel', function () {
    const activeElement = document.activeElement as any
    if (activeElement?.type === 'number') {
      activeElement?.blur()
    }
  })
}
